import { render, staticRenderFns } from "./commonSearch.vue?vue&type=template&id=2b50a08d&scoped=true&"
import script from "./commonSearch.vue?vue&type=script&lang=js&"
export * from "./commonSearch.vue?vue&type=script&lang=js&"
import style0 from "./commonSearch.vue?vue&type=style&index=0&id=2b50a08d&lang=less&scoped=true&"
import style1 from "./commonSearch.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b50a08d",
  null
  
)

export default component.exports